export const getElementBySelectorAsync = (selector: string, isId?: boolean): Promise<Element> => {
  return new Promise((resolve) => {
    const getElement = () => {
      const element = isId ? document.getElementById(selector) : document.querySelector(selector)
      if (element) {
        resolve(element)
      } else {
        requestAnimationFrame(getElement)
      }
    }

    getElement()
  })
}
